import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/departments")({
  component: () => (
    <Navigate to="/tenant-settings/users" search={{ tab: "departments" }} />
  ),
});
